import base from "@theme-ui/preset-base"
import { merge } from "theme-ui"

import "@fontsource/muli"
import "@fontsource/lato/400.css"

const theme = merge(base, {
  colors: {
    primary: "#fa0050",
    secondary: "#ffae1e",
  },
  fontSizes: [12, 14, 16, 22, 24, 32, 48, 64, 96],
  fonts: {
    heading: `'Muli', sans-serif`,
    body: `'Lato', sans-serif`,
  },
  fontWeights: {
    heading: 800,
    body: 400,
  },
  sizes: {
    container: 480,
  },
  layout: {
    header: {},
    main: {},
    footer: { textAlign: "center" },
    container: {
      maxWidth: "container",
      mx: "auto",
      px: 3,
    },
  },
  buttons: {
    primary: {
      borderRadius: 360,
      border: theme => `1px solid ${theme.colors.primary}`,
      ":hover": {
        bg: "background",
        color: "primary",
      },
    },
    product: {
      fontSize: 0,
      borderRadius: 360,
      height: 40,
      ml: "auto",
      border: theme => `1px solid ${theme.colors.primary}`,
      ":hover": {
        bg: "background",
        color: "primary",
      },
    },
    "qty-picker": {
      borderRadius: 360,
      width: 40,
      height: 40,
      fontSize: 0,
      border: theme => `1px solid ${theme.colors.primary}`,
      ":hover": {
        bg: "background",
        color: "primary",
      },
    },
  },
  cards: {
    primary: {
      boxShadow: "0 0 8px rgba(0, 0, 0, 0.125)",
      p: 3,
      borderRadius: "5px",
      bg: "background",
    },
  },
  forms: {
    label: {
      fontSize: 1,
      fontWeight: "bold",
    },
    input: {
      borderColor: "gray",
      bg: "background",
      "&:focus": {
        borderColor: "primary",
        boxShadow: t => `0 0 0 2px ${t.colors.primary}`,
        outline: "none",
      },
    },
    select: {
      borderColor: "gray",
      "&:focus": {
        borderColor: "primary",
        boxShadow: t => `0 0 0 2px ${t.colors.primary}`,
        outline: "none",
      },
    },
    textarea: {
      resize: "none",
      borderColor: "gray",
      bg: "background",
      "&:focus": {
        borderColor: "primary",
        boxShadow: t => `0 0 0 2px ${t.colors.primary}`,
        outline: "none",
      },
    },
  },
  styles: {
    root: {
      bg: "#f9f6f4",
      "*": {
        userSelect: "none",
      },
    },
    a: {
      textDecoration: "none",
      ":hover": {
        color: "secondary",
      },
    },
  },
})

console.log(theme)

export default theme
